"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Font = void 0;
class Font {
    constructor({ id, font_family, mime_type, path_to_regular, path_to_bold, legal, owner_id, created_at, updated_at } = {
        id: '',
        font_family: '',
        mime_type: '',
        path_to_regular: null,
        path_to_bold: null,
        legal: false,
        owner_id: 0,
        created_at: null,
        updated_at: null,
    }) {
        this.id = id;
        this.font_family = font_family;
        this.mime_type = mime_type;
        this.path_to_regular = path_to_regular;
        this.path_to_bold = path_to_bold;
        this.legal = legal;
        this.owner_id = owner_id;
        this.created_at = created_at;
        this.updated_at = updated_at;
    }
}
exports.Font = Font;
//# sourceMappingURL=font.js.map